export function schoolBillingVisible(user: {
  role?: string | null
  is_billing_actor?: boolean
  school_billing_hidden?: boolean
} | null | undefined): boolean {
  if (!user || user.school_billing_hidden) return false
  if (user.role === 'superadmin') return true
  return (user.role === 'director' || user.role === 'hr') && !!user.is_billing_actor
}
